var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"indexPanel"},_vm._l((_vm.indexList),function(item,index){return _c('Item',{key:index,attrs:{"indexList":item.titleLists,"tableName":item.name}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }